enum FileUploadResourceTypeEnum {
    catalog = "catalog",
    catalogItem = "catalogItem",
    orderItem = "orderItem",
    shipmentGroup = "shipmentGroup",
    shipment = "shipment",
    vendorResaleTaxDoc = "vendorResaleTaxDoc",
    vendorCreditCardAuthDoc = "vendorCreditCardAuthDoc",
    catalogItemFileAttachmentOne = "catalogItemFileAttachmentOne",
    catalogItemFileAttachmentTwo = "catalogItemFileAttachmentTwo",
    catalogItemFileAttachmentThree = "catalogItemFileAttachmentThree",
    catalogItemFileAttachmentFour = "catalogItemFileAttachmentFour",
    logo = "logo",
    bulkImages = "bulkImages",
    brandedLoginLogo = "brandedLoginLogo",
    docLogo = "docLogo",
    catalogItemTemplateCsv = "catalogItemTemplateCsv",
    childItemTemplateCsv = "childItemTemplateCsv",
    priceListCsv = "priceListCsv",
    vendorCsv = "vendorCsv",
    bulkOrdersCsv = "bulkOrdersCsv",
    purchaseOrderItem = "purchaseOrderItem",
    catalogItemCategoriesCsv = "catalogItemCategoriesCsv",
    vendorStateLicense = "vendorStateLicense",
    public = "public",
    priceBandsCsv = "priceBandsCsv",
    bulkItemOptionsCsv = "bulkItemOptionsCsv",
    catalogAttributesCsv = "catalogAttributesCsv",
    bulkKitBuilderCsv = "bulkKitBuilderCsv",
    priceBandsBulkApplyCsv = "priceBandsBulkApplyCsv",
}

export default FileUploadResourceTypeEnum;
